import { ICellRendererParams } from 'ag-grid-community'
import Icon from 'components/core-v2/atoms/Icon'
import React from 'react'

import { ReconciliationTableRowData } from '../reconciliation-utilities/map-data'

const IconCell = ({ breaking, warning }: ReconciliationTableRowData) => {
  if (breaking) {
    return <Icon name="circleWarning" size="default" />
  }
  if (warning) {
    return <Icon name="squareWarning" size="default" />
  }
  return <Icon name="circleCheck" size="default" />
}

export const DifferenceCell = ({
  data,
  value
}: ICellRendererParams<ReconciliationTableRowData, number>) => (
  <>
    <span>
      {value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 6 })}
    </span>
    <IconCell {...data} />
  </>
)
